// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".content[data-v-d6e868a2]{text-align:center}.content .el-button[data-v-d6e868a2]{margin-top:1.041667rem}", ""]);
// Exports
module.exports = exports;
